import { Grid } from '@mui/material';
import { RuleBuilderProvider } from '@procureai/rule-builder-ui-mui';
import { PageHeaderStatic, WidgetIcon } from '@procureai/ui-mui';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import { ModuleEntityType, RuleDomainType } from '~/common/types';
import { DomainIcon } from '~/components/DomainIcon/DomainIcon.tsx';
import { ModuleContextProvider, ModuleContextProviderValue } from '~/components/ModuleContextProvider';
import { useRuleDetail } from '~/modules';
import { RuleEvaluationLogWidget } from '~/modules/RuleEvaluationLogWidget/RuleEvaluationLogWidget.tsx';
import { RuleDetailPageTitle } from '~/routes/RuleDetail/components/RuleDetailPageTitle/RuleDetailPageTitle.tsx';

import { PageLayoutStyled } from './RuleEvaluationLog.styled.ts';

export const RuleEvaluationLog = () => {
  const { ruleId } = useRuleDetail();

  const contextValue = useMemo<ModuleContextProviderValue>(
    () => ({ entity: ModuleEntityType.RULE, entityId: ruleId }),
    [ruleId],
  );

  return (
    <RuleBuilderProvider>
      <PageLayoutStyled
        disablePadding
        fullHeight
        renderHeader={
          <PageHeaderStatic
            title={<RuleDetailPageTitle id={ruleId} />}
            maxWidth={false}
            icon={<WidgetIcon icon={<DomainIcon domain={RuleDomainType.RULE_SOURCING} />} />}
          />
        }
      >
        <ModuleContextProvider value={contextValue}>
          <Grid
            container
            direction="row"
            sx={{
              justifyContent: 'flex-start',
              alignItems: 'stretch',
              alignContent: 'stretch',
              flexGrow: 1,
              display: 'flex',
            }}
          >
            <Grid container size={8}>
              <Outlet />
            </Grid>
            <Grid
              container
              size={4}
              sx={{
                padding: 2,
              }}
            >
              <RuleEvaluationLogWidget />
            </Grid>
          </Grid>
        </ModuleContextProvider>
      </PageLayoutStyled>
    </RuleBuilderProvider>
  );
};
